<template>
	<div>
		<div class="top">
			<template v-if="carRadish == 20343882">
				<p class="aha">本内容由阿哈路书APP提供</p>
			</template>
			<form action="/">
				<van-search v-model="searchValue" shape="round" placeholder="请输入搜索关键词"  @search="onSearchLine"/>
			</form>
			<template v-if="carRadish == 20343882">
				<div class="tab">
					<div class="block active" @click="goline">
						<img src="../../assets/btn_tjls.png"/><p>推荐路书</p>
					</div>
					<div class="block" @click="goactivity">
						<img src="../../assets/btn_zjhd.png"/><p>自驾活动</p>
					</div>
					<div class="block" @click="gomdd">
						<img src="../../assets/btn_hyzg.png"/><p>环游中国</p>
					</div>
					<div class="block" @click="gomyorder">
						<img src="../../assets/btn_wddd.png"/><p>我的订单</p>
					</div>
					<div class="block" @click="gomyline">
						<img src="../../assets/btn_wdsc.png"/><p>我的收藏</p>
					</div>
				</div>
			</template>
			<div class="title_tap">
				<p @click="chooseStartCity">{{startCity}}</p>
				<p @click="chooseEndCity">{{endCity}}</p>
				<select @change="changeDay" v-model="totalDay">
					<!-- <option selected hidden disabled value="">天数</option> -->
					<option v-for="(item, index) in dayList" :value="item.val"  :key="index">{{item.name}}</option>
				</select>
				<select @change="changeTheme" v-model="theme">
					<!-- <option selected hidden disabled value="">主题</option> -->
					<option v-for="(item, index) in cateother" :value="item.cid"  :key="'cateother'+index">{{item.cname}}</option>
				</select>
			</div>
		</div>
		<div class="block_content">
			<div  v-if="carRadish == 20343882" class="mtop"></div>
			<h1 v-if="realCount==0 && totalCount>0" v-text="noreal"></h1>
			<div class="nototal" v-if="totalCount==0">
				<p v-text="nototal"></p>
				<p :class="button" v-text="establish" @click="goAPP"></p>
			</div>
			<div class="block_line" v-for="(item, index) in lineList" :key="index" @click="goLineInfo(item.id)">
				<h1>{{item.caption}}</h1>
				<p>{{item.startCity}}-{{item.endCity}}<em>|</em>{{item.totalDay}}天<em>|</em>往返{{item.totalDistance}}</p>
				<div class="img_content">
					<template v-for="(images, index) in item.album">
						<div class="img" v-if="index<3" :key="index">
							<img v-if="item.isFree==1 && index==0" src="../../assets/vip.png" class="vip">
							<img :src="images" >
							<span v-if="index==2">{{item.album.length}}图</span>
						</div>
					</template>
					
				</div>
				<div class="bottom">
					<div class="icon">
						<img v-if="item.userPic" :src="item.userPic">
						<img v-else src="../../assets/ld_img_avatar.png">
						{{item.userName}}
						<p><img src="../../assets/ls_icon_abrowse.png">{{item.clickNum}}</p>
					</div>
					<div class="score">{{item.score}} ★</div>
				</div>
			</div>
		</div>
		
		<!-- 城市选择 -->
		<div class="rule_shade"  v-show="showCity">
			<div class="shade_top">
				<form action="/">
					<van-search
						v-model="searchCity"
						show-action
						shape="round"
						placeholder="请输入搜索关键词"
						@input="onSearchCity"
						@cancel="onCancel"
					/>
				</form>
				<div class="searchList" v-show="searchShow">
					<p v-for="(item, index) in searchList" :key="index" @click="chooseCity({name:item,cid: ''})">{{item}}</p>
				</div>
				<div class="line">当前位置：<img src="../../assets/ls_icon_position.png">{{positionCity}}</div>
				<div class="line">当前城市：{{thisCity}}</div>
			</div>
			
			<van-index-bar :index-list="indexListInitial" :sticky-offset-top=143>
				<template v-if="historyCity.length">
					<div class="title">历史城市<span @click="clearHistoryCity">清除</span></div>
					<div class="hostCity">
						<template v-for="(item, index) in historyCity">
							<p :class="[{active: item.active}]" v-if="index<6" :key="index" @click="chooseCity(item)">{{item.name}}</p>
						</template>
					</div>
				</template>
				<div class="title">热门城市</div>
				<div class="hostCity">
					<p v-for="(item, index) in hostCity" :key="index" :class="[{active: item.active}]" @click="chooseCity(item)">{{item.name}}</p>
				</div>
				<div v-for="(item, index) in indexList" :key="index">
					<van-index-anchor :index="item.initial" />
					<div v-for="(city, cindex) in item.list" :key="cindex">
						<van-cell :title="city.name" @click="chooseCity(city)" />
					</div>
				</div>
			</van-index-bar>
		</div>
		<bottom></bottom>
	</div>
</template>
<script type="text/javascript" src="https://webapi.amap.com/maps?v=1.4.15&key=578f785bfb7302750cd1aa9a22e30b70"></script>
<script>
	import Vue from 'vue';
	import { Cell, CellGroup } from 'vant';
	import bottom from '@/components/bottom.vue';
	import {getCookie} from "@/utils/cookie/public";
	
	Vue.use(Cell);
	Vue.use(CellGroup);
	export default{
		components:{bottom},
		data() {
			return {
				noreal:'',
				nototal:'',
				establish:'',
				button:'',
				carRadish:'',
				searchValue:'',	//路书搜索
				searchCity:'',	//城市搜索
				searchList:'',	//搜索城市列表
				searchShow:false,
				cateother:[],	// 标签分类
				aroundChina:[],	//环游中国
				dayList:[],	//天数
				showCity: false,
				indexList: [],	
				indexListInitial: [],//字母锚点
				hot:[],	//热门城市
				lineList:[],	//路书列表
				positionCity:'定位中…',
				thisCity:'',
				isStartCity: true,
				startCity:'出发地',
				startCityId:'',
				endCity:'目的地',
				endCityId:'',
				historyCity: [],
				hostCity: [],
				theme:'',	//主题
				totalDay:'',
				page:'1',	//页码，默认第1页
				pageCount:'6',	//每页数量，默认6条,
				realCount:'',	//搜索结果数量
				totalCount:'',	//推荐结果数量
				keyword: '',
				isSearch: true, // 用来区分当前的请求是翻页的，还是根据搜索框或其他搜索条件搜索的，如果是翻页的，就需要把新的搜索结果加到之前的lineList后面，如果是搜索条件搜的，就需要把lineList清空
				query: {}
			};
		},
		computed: {
			device() {
				return String(this.$store.state.device).toString().toLowerCase()
			},
			// theme() {
			// 	return this.$route.query.theme ? this.$route.query.theme : '';
			// },
			// startCity(){
			// 	return this.$route.query.startCity ? this.$route.query.startCity : '';
			// },
		},
		mounted(){
			let appKey = getCookie('appKey');
			this.carRadish = appKey;
			this.keyword = this.$route.query.keyword ? this.$route.query.keyword : '';
			this.searchValue = this.keyword;
			this.theme = this.$route.query.theme ? this.$route.query.theme : '';
			this.created();				//滚动加载
			this.getCityList();
			this.getIndexInfo();
			setTimeout(() => {
				this.getLocation()
			}, 500);
			setTimeout(() => {
				this.getLineList()
			}, 1000);
			this.historyCity = localStorage.getItem('historyCity') ? JSON.parse(localStorage.getItem('historyCity')) : [];
			console.log(this.$route.query, this.$route.param);
			this.query = this.$route.query;
			if (this.query.endCity) {
				this.endCity = this.query.endCity
			}
			if (this.query.theme) {
				this.theme = this.query.theme
			}
			if (this.query.minDay && this.query.maxDay) {
				let minDay = '', maxDay = '';
				if (Number(this.query.minDay) <= 1 ) {
					minDay = 0;
					maxDay = 1;
				}
				if (Number(this.query.minDay) == 2 ) {
					minDay = 2;
					maxDay = 3;
				}
				if (Number(this.query.minDay) == 4 ) {
					minDay = 4;
					maxDay = 7;
				}
				if (Number(this.query.minDay) == 8 ) {
					minDay = 8;
					maxDay = 100;
				}
				this.totalDay = minDay + '|' + maxDay;
			}
		},
		methods: {
			created(){
				var that = this;
				window.onscroll = function(){
				//变量scrollTop是滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
				//变量windowHeight是可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//变量scrollHeight是滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
					//滚动条到底部的条件
					if(scrollTop+windowHeight==scrollHeight){
						//写后台加载数据的函数
						// console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
						console.log(that.page, that.pageCount);
						that.page ++ ;
						that.getLineList();
					}   
				}
			},
			// 获取当前位置
			getLocation () {
				let that = this;
				AMap.plugin('AMap.CitySearch', function () {
					var citySearch = new AMap.CitySearch();
					citySearch.getLocalCity(function (status, result) {
						if (status === 'complete' && result.info === 'OK') {
							// 查询成功，result即为当前所在城市信息
							let province = result.province;
							let city = result.city;
							console.log(city)
							if (that.query.startCity) {
								that.startCity = that.query.startCity
							}else{
								that.startCity = city
							}
							that.positionCity = city
						}
					})
				})
			},
			getIndexInfo(){
				var that = this;
				that.$ahaPost('/phone.php?m=default&a=recommend',{
				}).then(function(res) {
					if(res.code==1000){
						console.log(res);
						that.dayList = res.data.dayList;
						that.cateother = res.data.cateother;
					}
				}).catch(
					function(res) {
						console.log(res);
					}
				)
			},
			// 搜索
			onSearchLine(){
				this.keyword = this.searchValue;
				this.isSearch = true;
				this.page = 1;
				this.lineList = [];
				console.log(this.keyword)
				this.getLineList();
			},
			// 城市搜索
			onSearchCity(){
				let that = this;
				let cityValue = that.searchCity;
				console.log(cityValue)
				if(cityValue==""){
					that.searchShow = false
				}else{
					that.searchShow = true
				}
				that.$ahaPost('/phone.php?m=city&a=search',{
					keyWords:that.searchCity
				}).then(function(res) {
					if(res.code==1000){
						console.log(res);
						that.searchList = res.data.list
					}
				}).catch(
					function(res) {
						console.log(res);
					}
				)
			},
			onCancel(){
				this.showCity = false
			},
			// 选择出发地
			chooseStartCity(){
				this.searchCity = '';
				this.keyword = '';
				this.searchShow = false;
				this.isStartCity = true;
				this.showCity = true;
				this.hostCity.map((item) => {
					if (item.name == this.startCity) {
						item.active = true;
					} else {
						item.active = false;
					}
				})
				this.historyCity.map((item) => {
					if (item.name == this.startCity) {
						item.active = true;
					} else {
						item.active = false;
					}
				})
			},
			// 选择目的地
			chooseEndCity(){
				this.searchCity = '';
				this.keyword = '';
				this.searchShow = false;
				this.isStartCity = false;
				this.showCity = true;
				this.hostCity.map((item) => {
					if (item.name == this.endCity) {
						item.active = true;
					} else {
						item.active = false;
					}
				})
				this.historyCity.map((item) => {
					if (item.name == this.endCity) {
						item.active = true;
					} else {
						item.active = false;
					}
				})
			},
			// 城市列表
			getCityList(){
				var that = this;
				that.$ahaGet('/phone.php?m=city&a=getList',{
				}).then(function(res) {
					if(res.code==1000){
						console.log(res);
						that.indexList = res.data.domestic;
						that.indexListInitial = res.data.domestic.map((item) => {
							return item.initial;
						})
						that.hot = res.data.hot;
						that.hostCity = res.data.hot.list.map( (item, index) => {
							return {
								cid: item.cid,
								name: item.name,
								active: false
							}
						})
						console.log(that.hot,that.hostCity)
					}
				}).catch(
					function(res) {
						console.log(res);
					}
				)
			},
			// 获取路书列表数据
			getLineList(){
				var that = this;
				var param = {};
				param.page = that.page;
				param.pageCount = that.pageCount;
				param.keyword = that.keyword
				console.log('page:'+param.page)
				if (that.query.startCity) {
					param.startCity = that.query.startCity;
				} else {
					if (that.startCityId) {
						param.startCityId = that.startCityId;
					}
					if (that.startCity && that.startCity != '出发地') {
						param.startCity = that.startCity;
					}
				}
				if (that.query.endCityId) {
					param.endCityId = that.query.endCityId;
				} else {
					if (that.endCityId) {
						param.endCityId = that.endCityId;
					}
					if (that.endCity && that.endCity != '目的地') {
						param.endCity = that.endCity;
					}
				}
				if (that.query.minDay && that.query.maxDay) {
					param.minDay = that.query.minDay;
					param.maxDay = that.query.maxDay;
				} else {
					param.minDay = that.totalDay.split('|')[0] == 0 ? 1 : that.totalDay.split('|')[0];
					param.maxDay = that.totalDay.split('|')[1];
				}
				if (that.query.ids) {
					param.ids = that.query.ids;
				}
				
				if (that.theme) {
					param.theme = that.theme;
				}
				// console.log(param);return;
				console.log('positionCity:'+that.positionCity)
				console.log('startCity:'+that.startCity)
				that.$ahaPost('/phone.php?m=line&a=getlist', param).then(function(res) {
					if(res.code==1000){
						console.log(res);
						that.realCount = res.data.realCount;
						that.totalCount = res.data.totalCount;
						// if (res.data.realCount == 0) {
							that.noreal = '以下路书是否满足您的要求？';
							that.nototal = '还没看够？你也快来发一条吧！';
							that.establish = '创建路书';
							that.button = 'button';
						// }
						if (res.data.lineList) {
							that.lineList.push(...res.data.lineList);
							if (that.isSearch) {
								that.isSearch = false;
							}
						}
					}
				}).catch(
					function(res) {
						console.log(res);
					}
				)
			},
			// 选择城市
			chooseCity(item){
				let hasChosed = false;
				this.searchShow = false;
				if (this.historyCity.length) {
					// 让历史城市里被选中的城市active，并判断当前点击的城市是不是已经是历史城市
					this.historyCity.map((current) => {
						if (item.name == current.name) {
							hasChosed = true;
							current.active = true;
						} else {
							current.active = false;
						}
					});
					if (!hasChosed) {
						if (this.historyCity.length >= 6) {
							this.historyCity.splice(5,1)
						}
						this.historyCity.unshift({
							cid: item.cid,
							name: item.name,
							active: true
						});
					}
				} else {
					this.historyCity.push({
						cid: item.cid,
						name: item.name,
						active: true
					});
				}
				// 让热门城市里被选中的城市active
				this.hostCity.map((current) => {
					if (item.name == current.name) {
						current.active = true;
					} else {
						current.active = false;
					}
				})
				localStorage.setItem('historyCity', JSON.stringify(this.historyCity))
				console.log(this.historyCity);
				if (this.isStartCity) {
					this.startCityId = item.cid;
					this.startCity = item.name;
				} else {
					this.endCityId = item.cid;
					this.endCity = item.name;
				}
				this.thisCity = item.name
				this.showCity = false;
				this.page = 1;
				this.lineList = [];
				this.getLineList();
			},
			// 清除历史
			clearHistoryCity() {
				localStorage.removeItem('historyCity');
				this.historyCity = [];
			},
			// 选择天数
			changeDay(){
				this.totalDay = event.target.value;
				this.page = 1;
				this.lineList = [];
				this.getLineList();
			},
			// 选择主题
			changeTheme(){
				var that = this
				this.theme = event.target.value;
				console.log(this.theme)
				this.page = 1;
				this.lineList = [];
				this.getLineList();
			},
			// 进入路书详情
			goLineInfo(lineId){
				this.$router.push({path:"/line/details/"+ lineId});
			},
			// 下载APP
			goAPP(){
				var that=this;
				if (that.token==''){
					var refurl = encodeURIComponent(window.location.href);
					window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=user&a=login&refurl=${refurl}`
					return false;
				
				} else {
					// this.show = true;
					window.location.href = 'http://android.myapp.com/myapp/detail.htm?apkName=lushu.xoosh.cn.xoosh&ADTAG=mobile'
				}
			},
			// 腾讯越野相关跳转
			goline(){
				window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=line&a=getList&appKey=${this.carRadish}&_from=${this.device}`
			},
			goactivity(){
				window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=activity&a=getList&appKey=${this.carRadish}&_from=${this.device}`
			},
			gomdd(){
				window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=mdd&a=region&appKey=${this.carRadish}&_from=${this.device}`
			},
			gomyorder(){
				window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=myorder&a=getList&appKey=${this.carRadish}&_from=${this.device}`
			},
			gomyline(){
				window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=myline&a=getList&appKey=${this.carRadish}&_from=${this.device}`
			},
		},
	}
</script>

<style scoped>
	input{
		margin: 0 20px;
		flex: 1;
		border: 0;
		border-radius: 15px;
		font-size: 13px;
		color: #9EA0A4;
		padding: 8px 10px;
		padding-left: 30px;
		background: url(../../assets/ls_search_aicon.png) no-repeat 8px  #F3F5F9;
		background-size: 20px;
	}
	.block_content{
		margin-top: 110px;
	}
	h1{
		font-size: 16px;
		margin: 20px;
	}
	.title_tap{
		padding: 10px 20px;
		display: flex;
		justify-content: space-between;
		font-size: 12px;
		color: #595959;
		background: #fff;
	}
	.top{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 10;
		margin: 0;
		background: #fff;
	}
	.mtop{
		height: 120px;
	}
	.title_tap p{
		width: 90px;
		border-radius: 15px;
		padding: 5px 10px;
		margin-right:10px;
		background: url(../../assets/ls_btn_aexpand.png) no-repeat 90% #F3F5F9;
		background-size: 15px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	select{
		margin-right: 10px;
		padding: 5px 10px;
		width: 115px;
		border-radius: 15px;
		border: none;
		appearance: none;
		-moz-appearance: none;
		-webkit-appearance: none;
		background: url(../../assets/ls_btn_aexpand.png) no-repeat 90% #F3F5F9;
		background-size: 15px;
		font-size: 12px;
		color: #595959;
	}
	select:last-child{
		margin-right: 0;
	}
	.block_line{
		margin: 0 20px;
		border-bottom: 1.1px solid #e1e1e1;
	}
	.block_line h1{
		margin: 15px 0 5px 0;
	}
	.block_line p{
		font-size: 13px;
		color: #95979D;
	}
	.block_line em{
		color: #e1e1e1;
		margin: 0 5px;
	}
	.img_content{
		display: flex;
		justify-content: space-between;
		margin: 10px 0;
	}
	.img_content .img{
		width: 105px;
		height: 80px;
		position: relative;
		border-radius: 6px;
		overflow: hidden;
	}
	.img_content .img span{
		position: absolute;
		right: 5px;
		bottom: 5px;
		font-size: 11px;
		color: #fff;
		background: rgba(0,0,0,0.6);
		border-radius: 3px;
		padding: 2px 5px;
	}
	.img_content img{
		width: 100%;
		height: 100%;
	}
	.img_content .vip{
		width: 25px;
		height: 15px;
		position: absolute;
		top: 5px;
		left: 5px;
	}
	.block_line .bottom{
		display: flex;
		justify-content: space-between;
		padding-bottom: 15px;
	}
	.block_line .bottom .score{
		color: #606B80;
		font-size: 15px;
	}
	.block_line .icon{
		display: flex;
		align-items: center;
		font-size: 13px;
		color: #595959;
	}
	.block_line .icon img{
		width: 20px;
		height: 20px;
		margin-right: 5px;
		border-radius: 50%;
	}
	.block_line .bottom p{
		display: flex;
		align-items: center;
	}
	.block_line .bottom p img{
		width: 15px;
		height: 15px;
		margin-right: 5px;
	}
	.rule_shade{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		overflow-y: scroll;
		background: #F2F3F4;
		z-index: 99;
	}
	.shade_top{
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		z-index: 2;
		background: #fff;
	}
	.shade_search{
		display: flex;
		align-items: center;
		margin: 10px;
		font-size: 15px;
		overflow: hidden;
	}
	.shade_search input{
		margin: 0;
	}
	.rule_shade .title{
		font-size: 16px;
		font-weight: 800;
		padding: 0 10px;
		background: #fff;
		padding-top: 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.rule_shade .title span{
		color: #848689;
		font-size: 15px;
		font-weight: 500;
		margin-right: 10px;
	}
	.hostCity{
		font-size: 15px;
		display: flex;
		flex-wrap: wrap;
		padding: 10px;
		background: #fff;
	}
	.hostCity p{
		text-align: center;
		border-radius: 6px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 23%;
		margin: 5px 10px;
		border: 1.1px solid #e1e1e1;
		padding: 6px;
		background: #fff;
	}
	.hostCity p.active{
		color: #5F6B80;
		border: 1.1px solid #5F6B80;
	}
	.rule_shade .close{
		margin-left: 10px;
		margin-right: 10px;
	}
	.shade_top .line{
		display: flex;
		align-items: center;
		margin: 0 10px;
		padding: 12px 0;
		font-size: 16px;
		border-bottom: 1.1px solid #e1e1e1;
	}
	.shade_top .line:last-child{
		border-bottom: 0;
	}
	.rule_shade .line img{
		width: 15px;
		margin-right: 10px;
	}
	/deep/.van-index-bar__sidebar{
		top: 60%;
	}
	/deep/.van-index-bar{
		margin-top: 165px;
	}
	/deep/.van-index-anchor--sticky{
		background: #F2F3F4;
	}
	.searchList{
		position: absolute;
		background: #fff;
		width: 100%;
		top: 50px;
		height: calc(100vh - 50px);
		overflow-y: scroll;
	}
	.searchList p{
		padding: 10px 0;
		font-size: 15px;
		margin: 0 10px;
		border-bottom: 1.1px solid #e1e1e1;
	}
	.aha{
		font-size: 15px;
		text-align: center;
		color: #848689;
		margin-top: 10px;
	}
	.tab{
		display: flex;
		justify-content: space-between;
		margin:10px;
		font-size: 12px;
	}
	.tab img{
		width: 100%;
	}
	.tab .block{
		flex: 1;
		/* margin: 0 5px; */
		text-align: center;
		border-radius: 12px;
		padding: 10px;
	}
	.tab .active{
		background: #F3F5F9;
	}
	.nototal{
		margin: 10px 20px;
		font-size: 15px;
		color: #848689;
		text-align: center;
	}
	.nototal .button{
		color: #fff;
		background: #5F6B80;
		font-size: 16px;
		width: 110px;
		margin: 20px auto;
		border-radius: 100px;
		padding: 10px 0;
		text-align: center;
	}
</style>
